<template>
  <Layout>
    <router-view></router-view>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'

export default {
  name: 'SalesView',
  components: { Layout }
}
</script>
